<script lang="ts">
  import { LoadingSpinner } from "$lib/ui/loading-spinner";
  const { timeout = 60_000, message = "Loading..." } = $props<{
    timeout?: number;
    message?: string;
  }>();
  let isLoading = $state<boolean>(true);
  let isTimeout = $state<boolean>(false);
  $effect(() => {
    const timeoutId = setTimeout(() => {
      isLoading = false;
      isTimeout = true;
    }, timeout);
    return () => clearTimeout(timeoutId);
  });
</script>

<div class="flex justify-center items-center h-screen">
  {#if isTimeout}
    <div class="flex flex-col gap-2 items-center">
      <p class="text-offblack">Oops! Something went wrong.</p>
      <p class="text-offblack">Please refresh the page and try again.</p>
    </div>
  {:else}
    <div class="flex flex-col gap-2 items-center">
      <LoadingSpinner />
      <p class="text-offblack">{message}</p>
    </div>
  {/if}
</div>
